export default class HostDetectionModule {

  static detectScriptHost() {
    let suffix = '/adw-tag.js';
    let host = '';

    let scriptElements = document.getElementsByTagName('SCRIPT');
    for (let i = 0; i < scriptElements.length; i++) {
      let scriptEl = scriptElements[i];
      let src = scriptEl.getAttribute('src');
      if (src && src.endsWith(suffix)) {
        host = src.substring(0, src.indexOf(suffix));
        break;
      }
    }

    return host;
  }

  static detectDynamicWidgetHost() {
    let scriptHost = HostDetectionModule.detectScriptHost();

    let scriptProdHosts = ['static.aperza.jp', 'static.aperza.com'];
    let scriptStgHosts = ['static.stg.aperza.jp', 'static.stg.aperza.com'];
    let scriptTestHosts = ['static.test.aperza.jp', 'static.test.aperza.com'];

    if (HostDetectionModule.containsAny(scriptHost, scriptProdHosts)) {
      return 'https://dw.aperza.com';
    } else if (HostDetectionModule.containsAny(scriptHost, scriptStgHosts)) {
      return 'https://dw.stg.aperza.com';
    } else if (HostDetectionModule.containsAny(scriptHost, scriptTestHosts)) {
      return 'https://dw.test.aperza.com';
    }

    return 'http://localhost:8080';
  }

  static containsAny(text, values = []) {
    for (let value of values) {
      if (text.includes(value)) {
        return true;
      }
    }
    return false;
  }

}
